export enum RenderStrategy {
    STATIC = "static",
    DYNAMIC = "dynamic",
}

export enum RenderMode {
    MODE_3D = "3d",
    MODE_2D = "2d"
}

export enum AppVersion {
    LTM = "ltm",
    DSM = "dsm"
}